function property_Reducer(state = [], action) {
    switch (action.type) {
        case 'PROPERTY/SET':            
            return action.property;
        case 'PROPERTY/CLEAR':
            return null;
        default:
            return state;
    }
}

export default property_Reducer;
